import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PROJECT_MANAGEMENT_URL } from '@insite-store360/shared';
import { Observable, catchError } from 'rxjs';
import { ErrorHandlerService } from './error-handler.service';

@Injectable({
    providedIn: 'root',
})
export class ConfirmationQntService {
    private readonly URL_PATH = `${PROJECT_MANAGEMENT_URL}/confirmationQnt`;

    constructor(
        private http: HttpClient,
        private errorHandler: ErrorHandlerService
    ) { }

    /**
     * Save confirmation quantity for a lead
     */
    public saveConfirmationQnt(
        leadId: number, 
        remarks: string, 
        mockUpRoom: boolean,
        confirmationQuantities: Array<{ productId: number; confirmationQuantity: number }>,
        countryId?: number
    ): Observable<{ message: string; confirmationQnt: any }> {
        let url = `${this.URL_PATH}/saveConfirmationQnt/${leadId}`;
        if (countryId) {
            url += `?countryId=${countryId}`;
        }
        return this.http
            .post<{ message: string; confirmationQnt: any }>(url, { 
                remarks, 
                mockUpRoom, 
                confirmationQuantities 
            })
            .pipe(catchError(this.errorHandler.handleError));
    }

    /**
     * Get confirmation quantity for a lead
     */
    public getConfirmationQnt(leadId: number, batchId?: number): Observable<{ remarks: string; mockUpRoom: boolean; confirmationQuantities: any[] }> {
        let url = `${this.URL_PATH}/getConfirmationQnt/${leadId}`;
        if (batchId) {
            url += `?batchId=${batchId}`;
        }
        return this.http
            .get<{ remarks: string; mockUpRoom: boolean; confirmationQuantities: any[] }>(url)
            .pipe(catchError(this.errorHandler.handleError));
    }

    /**
     * Get confirmation quantity by lead ID
     */
    public getConfirmationQntByLeadId(leadId: number, batchId?: number): Observable<any> {
        let url = `${this.URL_PATH}/getByLeadId/${leadId}`;
        if (batchId) {
            url += `?batchId=${batchId}`;
        }
        return this.http
            .get<any>(url)
            .pipe(catchError(this.errorHandler.handleError));
    }
}

